import { render, staticRenderFns } from "./MaskIcon.vue?vue&type=template&id=0a0063ed&scoped=true&"
import script from "./MaskIcon.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MaskIcon.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MaskIcon.vue?vue&type=style&index=0&id=0a0063ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0063ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a0063ed')) {
      api.createRecord('0a0063ed', component.options)
    } else {
      api.reload('0a0063ed', component.options)
    }
    module.hot.accept("./MaskIcon.vue?vue&type=template&id=0a0063ed&scoped=true&", function () {
      api.rerender('0a0063ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/MaskIcon.vue"
export default component.exports